<app-popup-view>
    <app-vehicle-details [isNewView]="true"></app-vehicle-details>
</app-popup-view>
